import { render, staticRenderFns } from "./Ymca.vue?vue&type=template&id=4a70bcbc&scoped=true&"
import script from "./Ymca.js?vue&type=script&lang=js&"
export * from "./Ymca.js?vue&type=script&lang=js&"
import style0 from "./Ymca.scss?vue&type=style&index=0&id=4a70bcbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a70bcbc",
  null
  
)

export default component.exports